import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
function Portfoliocard() {
  
    const projects = [
        {
            id:1,
            title: "Automating Success with Testing for Great Dwellings",
            category: "Web",
            imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d1e57d45178d9ce5006d6_GreatDwellings2B_1260.jpg",
            link: "/portfolio",
        },
        {
            id:2,
            title: "UI Design and Branding for Children’s book series",
            category: "Branding",
            imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/62321cbe7fd75424e426e23d_NetAesthetics_Portfolio_Noah-and-Blue-Banner.jpg",
            link: "/portfolio",
        },
        {
            id:3,
            title: "ERC's Fair Housing Checklist Mobile App",
            category: "Mobile",
            imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/6273985f162e55b6627b2d95_NetAesthetics_Portfolio_Fair-Housing-Thumbnail.jpg",
            link: "/portfolio",
        },
        {  
            id:4,
            title: "Cloud-based Mobile App for Smarter Voting",
            category: "Mobile",
            imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/627394b2b6db63f20ffdea4e_NetAesthetics_Portfolio_SmarterVote-Thumbnail.jpg",
            link: "/portfolio",
        },
        {
            id:5,
            title: "Blackbox Testing the Yelp for those with Disabilities",
            category: "Multi-Platform",
            imageUrl: "https://cdn.prod.website-files.com/61962f94f13cb612b8c209e2/620d1e472b488cb717066e52_wheelchair_access_A11y.jpg",
            link: "/portfolio",
            customStyle: { marginLeft: { xs: 'auto', md: '220px' } }
        },
        {
            id:6,
            title: "Revolutionizing Student Mental Health Support",
            category: "Multi-Platform",
            imageUrl:'https://possip.com/wp-content/uploads/2021/10/supporting-mental-health.png',
            link: "/portfolio",
            customStyle: { marginLeft: { xs: 'auto', md: '220px' } }
        }
    ];
  return (
    
  <>
    
    <div className='blog_section wow animate__fadeInUp' data-wow-duration="1s">
        {projects.map((project, index) => (
            <Card className='muicard' key={index}>
                <Box
                    sx={{
                        position: 'relative',
                        height: 265,
                        backgroundImage: `url(${project.imageUrl})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                    }}
                >
                    <Box className="categorytext" sx={project.customStyle}>
                        {project.category}
                    </Box>
                </Box>
                <CardContent style={{textAlign:'left'}}>
                    <a  href={`/portfolio/${project.id}`} className='typographytext' variant="body2">
                        {project.title}
                    </a>
                </CardContent>
                <CardActions sx={{
                    flexDirection: 'column',
                    textAlign: 'left',
                    alignItems: 'flex-start',
                }}>
                    <a  href={`/portfolio/${project.id}`} className='muireadmore'>Read More <span className="arrow_icon"> ↗</span></a>
                    <div className='underline_animation'></div>
                </CardActions>
            </Card>
        ))}
    </div>
   </>

  )
}

export default Portfoliocard